module.exports = {"450224100":"长安镇","450224101":"浮石镇","450224102":"泗顶镇","450224103":"板榄镇","450224104":"大将镇","450224105":"大良镇","450224200":"雅瑶乡","450224201":"大坡乡","450224202":"东起乡","450224203":"沙子乡","450224204":"桥板乡","450224205":"潭头乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450224.json
// module id = 2216
// module chunks = 0